import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import AdsLayer from "./AdsLayer";


const AdsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Components / Company Categories" />

                <AdsLayer />

            </MasterLayout>
        </>
    );
};

export default AdsPage;
